import React, { Suspense, useEffect, useState } from 'react'
import Desktop from './pages/desktop/Desktop'
import './App.css'
import { Route, Routes } from 'react-router-dom'
import Auth from './pages/auth/Auth'
import Loading from './components/loading/Loading'
import PrivateRoute from './router/PrivateRoute'
import { axios } from 'src/api'
import { Alert, Button } from '@mui/material'
import { useAppSelector } from './hooks'
import { selectUser } from './redux'
import { Sentry } from './config'
import ErrorPage from './pages/errorPage/ErrorPage'
import useLegacyOsAdapters from './hooks/useLegacyOsAdapters'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'

// LOCALIZATION LOCALE AND ADAPTERS
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment'
import DesktopAlertContextProvider from './contexts/DesktopAlert.context'
import ToastContextProvider from './contexts/Toast.context'

// eslint-disable-next-line camelcase
declare let __webpack_hash__: string

const App = () => {
  const { userName } = useAppSelector(selectUser)
  useLegacyOsAdapters()

  const [isOldVersion, setIsOldVersion] = useState(false)

  useEffect(() => {
    const checkVersion = async () => {
      // eslint-disable-next-line camelcase
      const hash = __webpack_hash__
      const currentHash = await axios.get('/meta.json')
      if (hash !== currentHash.data.hash) setIsOldVersion(true)
    }

    if (window.location.hostname.includes('availroom')) {
      document.domain = 'availroom.com'
    }
    const isProduction = process.env.NODE_ENV === 'production'

    if (isProduction) checkVersion()
  }, [])

  useEffect(() => {
    if (userName) {
      Sentry.setUser({
        id: userName,
        email: userName
      })
    }
  }, [userName])

  const handleUpdateVersion = () => {
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(async (name) => {
          await caches.delete(name)
        })
      })

      window.location.reload()
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='es'>
      <DesktopAlertContextProvider>
        <ToastContextProvider>
          <div className='App'>
            {isOldVersion && (
              <Alert severity='info'>
                ¡Hay una versión nueva disponible!
                <Button
                  onClick={handleUpdateVersion}
                  sx={{
                    marginLeft: '1rem'
                  }}
                  variant='contained'
                >
                  Actualizar
                </Button>
              </Alert>
            )}
            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path='/login' element={<Auth />} />
                <Route path='/error' element={<ErrorPage />} />
                <Route
                  path='/'
                  element={
                    <PrivateRoute>
                      <Desktop />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </Suspense>
          </div>
        </ToastContextProvider>
      </DesktopAlertContextProvider>
    </LocalizationProvider>
  )
}

export default App
